export default __webpack_public_path__ + "static/media/youtube.e3335a41.svg";